import { render, staticRenderFns } from "./WarningLanguageIcon.vue?vue&type=template&id=d68cca1e&scoped=true&"
import script from "./WarningLanguageIcon.vue?vue&type=script&lang=js&"
export * from "./WarningLanguageIcon.vue?vue&type=script&lang=js&"
import style0 from "./WarningLanguageIcon.vue?vue&type=style&index=0&id=d68cca1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68cca1e",
  null
  
)

export default component.exports